// CX Genie 的嵌入腳本在 script onload 之後才非同步掛載 widget，
// window.openCXGenieChatWidget / closeCXGenieChatWidget 是那之後才被定義的，
// 因此 script onload 不等於 widget API 就緒（CLIENT-PWA-SSR-TP）。
// CX Genie 未提供 onReady 之類的就緒事件，只能輪詢這兩個 global 是否已存在。
const WIDGET_API_POLL_INTERVAL_MS = 100
const WIDGET_API_MAX_WAIT_MS = 15_000
const WIDGET_API_MAX_ATTEMPTS = WIDGET_API_MAX_WAIT_MS / WIDGET_API_POLL_INTERVAL_MS

function isWidgetApiReady() {
  return typeof window.openCXGenieChatWidget === 'function' && typeof window.closeCXGenieChatWidget === 'function'
}

export function setupCxgenie(item, locale) {
  if (!item?.link) return null
  const cxgenieScript = document.createElement('script')
  cxgenieScript.src = item.link
  cxgenieScript.setAttribute('data-aid', item.id)
  cxgenieScript.setAttribute('data-lang', locale)
  cxgenieScript.setAttribute('data-hide-widget-button', 'true')
  document.head.appendChild(cxgenieScript)

  let callback = null
  let readyTimer = null
  let readyAttempts = 0

  function cxGenieCall(action, param) {
    // 以「widget API 當下是否存在」為就緒依據，而非一次性的 load 旗標：
    // 旗標一旦在 API 還沒掛上時被設為就緒就會一直說謊，反之逾時放棄後也會永遠說未就緒。
    if (!isWidgetApiReady()) {
      callback = function () {
        cxGenieCall(action, param)
      }
      // 只要存在待送動作，就必須有人在盯著就緒狀態，否則沒有任何機制會把它沖出來
      // （`onload` 只觸發一次，等待逾時後也不會自己重啟）。
      ensureWaitingForWidgetApi()
      return
    }

    switch (action) {
      case 'maximize':
        window.openCXGenieChatWidget()
        break
      case 'minimize':
        window.closeCXGenieChatWidget()
        break
      case 'hide':
        window.closeCXGenieChatWidget()
        break
      case 'setUser':
        console.log('CX Genie Can not set user.')
        break
      default:
        console.log('Unknown CX Genie Action')
        break
    }
  }

  function stopWaitingForWidgetApi() {
    clearInterval(readyTimer)
    readyTimer = null
  }

  function flushPendingCall() {
    console.log('[Customer Service] CX Genie Ready')
    if (!callback) return
    // 這裡是 load / timer 回呼，不在 maximize() 等對外方法的 try-catch 保護範圍內，
    // 一旦拋出就會變成未捕捉例外（CLIENT-PWA-SSR-TP）。
    try {
      callback()
    } catch (error) {
      console.warn('[Customer Service] CX Genie action error:', error)
    }
    callback = null
  }

  function ensureWaitingForWidgetApi() {
    if (readyTimer !== null) return

    if (isWidgetApiReady()) {
      flushPendingCall()
      return
    }

    readyAttempts = 0
    readyTimer = setInterval(() => {
      if (isWidgetApiReady()) {
        stopWaitingForWidgetApi()
        flushPendingCall()
        return
      }

      readyAttempts += 1
      if (readyAttempts >= WIDGET_API_MAX_ATTEMPTS) {
        stopWaitingForWidgetApi()
        callback = null
        console.warn('[Customer Service] CX Genie widget API 逾時未就緒，已停止等待')
      }
    }, WIDGET_API_POLL_INTERVAL_MS)
  }

  cxgenieScript.onload = () => {
    // widget 要到腳本執行完才開始掛載，故以「載入完成」為起點重新給足等待時間；
    // 否則載入前的點擊所開啟的等待會把額度用在腳本還在下載的期間。
    readyAttempts = 0
    ensureWaitingForWidgetApi()
  }

  return {
    maximize() {
      try {
        cxGenieCall('maximize')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    minimize() {
      try {
        cxGenieCall('minimize')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    hide() {
      try {
        cxGenieCall('hide')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    setUser(uidSite) {
      try {
        cxGenieCall('setUser', { user_id: uidSite, user_name: uidSite })
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
  }
}
